import { LoadingKey } from '../app-active-loading/LoadingKey';
import { getSentryExtra } from '../error/getSentryExtra';
import { EndpointKey } from '../http/EndpointKey';
import Logger from '../lib/Logger';
import { googleContactsSaveConnection } from '../store/auth/action-creators';
import { completeStepAction } from '../store/flow/action-creators';
import { clearLoadingStatus } from '../store/loading-status/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { Step } from 'signup-constants/Step';
import { GoogleSyncAlertValue, SignupInteractionByEndpointKey } from './googleContactsSyncConstants';
import { setGoogleContactsSyncAlertCookieForUserGuideAlert } from './googleContactsSyncUtils';
const LOG = Logger.getLogger('googleContactsSyncHandlers');
export const handleGoogleContactsRequestError = endpointKey => dispatch => {
  dispatch(Tracker.signupInteraction(SignupInteractionByEndpointKey[endpointKey]));
  dispatch(completeStepAction({
    stepKey: Step.GoogleContactsSync
  }));
  dispatch(clearLoadingStatus(LoadingKey.GoogleContactsSyncLoading));
  setGoogleContactsSyncAlertCookieForUserGuideAlert(GoogleSyncAlertValue.warning);
};
export const handleLoginBeforeGoogleContactsSyncError = (error, dispatch) => {
  const {
    status
  } = error;
  LOG.warn(`attemptUserLogin-cookie: ${status || 'no-status'}`, {
    extra: getSentryExtra(error)
  });
  dispatch(Tracker.signupInteraction('login-before-google-data-sync-error'));
};
export const handleGoogleContactsCreateConnectionSuccess = (response, dispatch) => {
  const {
    id: connectionId
  } = response;
  if (connectionId) {
    dispatch(googleContactsSaveConnection(connectionId));
  } else {
    dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsCreateConnection));
  }
};
export const handleGoogleContactsCreateConnectionError = (error, dispatch) => {
  if (error && error.status && error.status === 403 && error.responseJSON && error.responseJSON.category) {
    dispatch(Tracker.signupInteraction(`data-sync-create-connection-error-${error.responseJSON.category}`));
  }
  dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsCreateConnection));
};